import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import MaterialTable from 'material-table';
import { withRouter } from 'react-router-dom';
import { Paginationn } from '../common/pagination'
import { appConfig } from "../common/constants";

function CommonGrid(props) {
  const newdata = props.columns.map(v => (
    v["render"] == undefined ?
      {
        ...v, "render": data => data[v.field] == ("" || null || undefined) || data[v.field].length == 0 ? '---' :
          data[v.field]
      } : v))
  return (
    <div className={props.showPadding ? "" : "mb-3"}>

      <MaterialTable
        style={{ boxShadow: "none" }}
        columns={newdata}
        data={props.data}
        title={props.title && props.title}
        // actions={[
        //   rowData => ({
        //     icon: 'delete',
        //     tooltip: 'Delete User',
        //     onClick: (event, rowData) => Window.confirm("You want to delete " + rowData.name),
        //   })
        // ]}
        onRowClick={(event, rowData) => {
          event.preventDefault();
          props.handleRowClick(event, rowData);
        }}
        onSelectionChange={(rowData) => { props.rowsSelected(rowData) }}
        options={{
          selection: props.selection ? true : false,
          showTextRowsSelected: false,
          actionsColumnIndex: -1,
          searchFieldAlignment: props.title ? 'right' : 'left',
          showTitle: props.title ? props.title : false,
          search: props.search ? true : false,
          // grouping:true,
          paging: props.data.length > 5 ? true : false,
          sorting: props.data.length > 2 ? true : false,
          paginationType: "stepped",
          pageSizeOptions: [5, props.data.length >= 10 && 10, props.data.length >= 20 ? 20 : props.data.length > 11 && props.data.length < 20 ? props.data.length : ""],
          // exportButton:true,
          // exportAllData:true,
          headerStyle: {
            backgroundColor: props.thColor || "#f0f5ff",
            textAlign: 'left',
            flexDirection: 'row'
          },
          cellStyle: {
            textAlign: 'left',
            flexDirection: 'row',
          },
          rowStyle: rowData => ({
            backgroundColor: "#fff",
            opacity: rowData.status === "Resolved" ? 0.3 : 1,
            pointerEvents: rowData.status === "Resolved" ? 'none' : 'auto'
          }),
          padding: 'dense',
          draggable: true

        }}
        localization={{
          header: {
            actions: 'Actions'
          },
          body: {
            emptyDataSourceMessage: props.langData?.length > 0 ? props.langData.find(item => item.keyword === "resources_no_records_lbl")?.[props.lang] || 'No records to display' : 'No records to display'
          }
        }}
      // components={{
      //   Action: props => (
      //     <div
      //       className="fullwidth text-center text-danger"
      //     >
      //       <i className="far fa-trash-alt fa-lg"></i>
      //     </div>
      //   ),
      // }}
      />
    </div>
  )

}

const mapStateToProps = (state) => {
  return {
    //   formValues: state.form,
    langData: state.langData,
    lang: state.lang,
    state
  }
}
export default withRouter(connect(mapStateToProps,)(CommonGrid));

